{
  "Year": "År",
  "Minutes": "Minuter",
  "minutes": "minuter",
  "minute": "1 minut",
  "minute_plural": "{{count}} minuter",
  "Hours": "Timmar",
  "hour": "1 timme",
  "hour_plural": "{{count}} timmar",
  "Monday": "Måndag",
  "Tuesday": "Tisdag",
  "Wednesday": "Onsdag",
  "Thursday": "Torsdag",
  "Friday": "Fredag",
  "Saturday": "Lördag",
  "Sunday": "Söndag",
  "day": "dag",
  "week": "vecka",
  "month": "månad",
  "year": "år"
}
